/** Real bonus covers generated by Impultienda for each bonus ebook (public ebook-images bucket). */
const EB = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/6c1a724c-31a4-442a-bc25-af15f66c889e/'
export const BONUS_COVERS: Record<string, string> = {
  BONUS_01: `${EB}368595d0-ccd3-4af1-bb5d-b5d3e21e5c63-mockup.webp`,
  BONUS_02: `${EB}f2b3e5a1-92a1-406f-acbf-511aa4e2d118-mockup.webp`,
  BONUS_03: `${EB}93052eef-2f58-49ba-b234-133fb7ca3114-mockup.webp`,
  BONUS_04: `${EB}b7f4a9f7-42d8-4447-aff4-31b092501d4b-mockup.webp`,
  BONUS_05: `${EB}0c6ce323-a9f7-4685-bd71-133b0165574d-mockup.webp`,
}
